<template>
  <bs-abnormal
    v-if="isForbidden"
    type="linkNoAccess"
  />
  <bs-auth
    v-else-if="isAuth"
    :data="data"
    @authToken="authToken"
  />
  <!-- 外链文件 -->
  <div
    v-else
    class="link-box"
    style="width: 100%; height: 100%"
  >
    <!-- eod提示 -->
    <div
      v-show="!isFullScreen && shareInfo.isSecurity && eodTipH"
      class="link-header-tip"
      :style="{height: `${eodTipH}px`, 'line-height': `${eodTipH}px`}"
    >
      {{ $t('该文件的安全级别较高，您需要下载专用软件才可以使用（仅支持windows用户）') }}
      <a
        href="/client/eod-Sandbox-plug-in/zBox_eod.rar"
        class="download-area"
      >
        {{ $t('点击下载') }}
      </a>{{ $t('软件') }}
      <svg
        class="close-icon"
        @click="closeHeaderTip"
      >
        <use xlink:href="#close" />
      </svg>
    </div>
    <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
    <bs-structure
      :display-right="displayRightPanel"
      :box-tip-h="eodTipH"
      :is-full-screen="isFullScreen"
      :box-margin-r="20"
      :box-margin-l="20"
    >
      <!-- header -->
      <template slot="boxHeader">
        <bs-header :data="data">
          <div class="fl-r lh-50">
            <co-button
              v-if="topBtnPower.showDown"
              @click="downFile"
            >
              {{ $t('下载') }}
            </co-button>
            <!--<co-button-->
            <!--v-if="isShowSlideBtn"-->
            <!--@click="isSideMode = !isSideMode"-->
            <!--&gt;-->
            <!--{{ isSideMode?$t('预览模式'):$t('幻灯片模式') }}-->
            <!--</co-button>-->
            <bs-button
              v-if="topBtnPower.showSaveBox"
              self-class="s-btn"
              @click="saveBox"
            >
              {{ $t('转存至网盘') }}
            </bs-button>
            <bs-qrcode />
            <co-button
              self-class="right-pannel c-btn"
              @click="toggleRightColumn"
            >
              <template name="default">
                <svg class="right-pannel-icon">
                  <use :xlink:href="rPanelIcon" />
                </svg>
              </template>
            </co-button>
          </div>
        </bs-header>
      </template>
      <!-- body -->
      <template slot="boxBody">
        <div
          class="link-box-body"
          @mousemove="footMouseMove"
        >
          <!--上部预览-->
          <div
            class="link-box-main"
            :style="{height:isShowFoot?'calc(100% - 50px)':'100%'}"
          >
            <!-- 正常预览 -->
            <bs-switch
              v-if="!abnormalType"
              ref="bsswitch"
              :is-side-mode="isSideMode"
              :is-delivery="true"
              @loadFail="loadFail"
            />
            <!-- 异常预览提示 -->
            <bs-abnormal
              v-else
              :data="metaData"
              :type="abnormalType"
              :abnormal-data="abnormalData"
              @abnormal="abnormal"
            />
          </div>
          <!--下部底部栏-->
          <div
            v-show="isShowFoot"
            class="link-box-footer"
          >
            <bs-PdftoolBar
              ref="pdftoolbar"
              :data="metaData"
              :doc-check="docCheck"
              @presentationMode="presentationMode"
            />
          </div>
          <!--外链下载-->
          <iframe
            id="download-iframe"
            src="javascript:false;"
            width="0"
            heigth="0"
            border="none"
            style="display:none"
          />
        </div>
      </template>
      <template slot="boxRight">
        <!--right panel-->
        <div
          v-show="displayRightPanel"
          class="link-right"
        >
          <bsLinkRight :data="metaData" />
        </div>
      </template>
    </bs-structure>
    <!--dialog-->
    <co-dialog
      v-if="dialog.isShow"
      ref="dilogEl"
      v-model="dialog.isShow"
      :title="dialog.title"
      :show-footer="false"
    >
      <component
        :is="dialogComponent"
        :data="data"
        :selected-data="selectedData"
        @closeDialog="closeDialog"
        @refreshList="successBack"
      />
    </co-dialog>
  </div>
</template>
<script>
import { getAuthToken } from 'components/business/link/auth/fiveMinAuth'
import _$ from 'js/api/getdata'
import bsStructure from 'components/business/structure/index.vue'
import bsLinkRight from 'components/business/link/linkright/index.vue'
import bsHeader from 'components/business/link/header/index.vue'
import bsSwitch from 'components/business/switch/index.vue'
import bsAbnormal from 'components/business/abnormal/index.vue'
import bsPdftoolBar from 'components/business/pdftoolbar/index.vue'
import bsAuth from 'components/business/link/auth/index.vue' // 外链提取码页面
import bsQrcode from 'components/business/qrcode/index.vue'
import {
  isExcel, resolveFileAction, isClient, gotoLogin, resolveMultiDomain, formatDate,
} from 'js/util/util'
import coButton from 'components/common/button/index.vue'
import { linkDownLoad } from 'js/api/download/linkDown'
import bsButton from 'components/business/link/lbutton/index.vue'
import { PREVIEW } from 'js/mixin/common'
import coDialog from 'components/common/dialog/index.vue'
import transferSave from 'components/business/link/transfer/index.vue'
import { LINKFILE } from 'js/mixin/linkcommon'
import { sendLogBuryingPointMethods } from 'js/download-service/service-download'
import * as Util from 'js/util/util'

export default {
  components: {
    bsStructure,
    bsLinkRight,
    bsHeader,
    bsSwitch,
    bsAbnormal,
    bsPdftoolBar,
    bsAuth,
    bsQrcode,
    coButton,
    bsButton,
    coDialog,
    transferSave,
  },
  /**
         * 主要混入的函数
         * showFoot
         * footMouseMove
         * pushEsc
         * checkfull
         * loadFail
         * LINKFILE中:
         * linkPreviewLimit
         * accountSupport
         * nonTrialAccount
         * typeSupport
         * checkPreSupport
         * showAbornomal
         * sendRecent
         */
  mixins: [PREVIEW, LINKFILE],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isAuth: false, // 是否要输入提取码
      isForbidden: false,
      metaData: {}, // 数据信息
      displayRightPanel: true, // 默认展开右侧栏
      eodTipH: 0, // 安全外链的eod下载提示的高度，如果是0则没有
      abnormalType: '', // 异常类型
      isSideMode: false,
      isShowFoot: true, // 是否显示底部栏
      topBtnPower: { // 顶部数据信息
        showDown: false, // 下载
        showSaveBox: false, // 转存
      },
      // 链接数据
      shareInfo: {
        isSecurity: false, // 安全外链
        isApprove: false, // 审批外链
        isTrial: false, // 体验用户
        isLogin: false, // 是否登录认证
      },
      authData: {}, // 外链预览所需的参数
      dialogComponent: '', // dialog 组件名
      dialog: {
        isShow: false,
        title: '',
      },
      selectedData: null, // 用于转存组件 传递数据，不用metaData的原因是格式不一样
      abnormalData: {}, // 异常需要的额外数据
    }
  },
  computed: {
    /**
             * 是否显示幻灯片模式
             */
    isShowSlideBtn() {
      return this.metaData && (/ppt|dps/i.test(this.metaData.mime_type)) && !isClient()
    },
    rPanelIcon() {
      let icon
      if (this.displayRightPanel) {
        icon = '#retractRightcolumn'
      } else if (this.abnormalType === 'noAccess') {
        icon = '#disExpendRightcolumn'
      } else {
        icon = '#expendRightcolumn'
      }
      return icon
    },
    isMac() {
      return Util.isMac()
    },
  },
  watch: {
    data: {
      handler(n) {
        this.shareInfo.isSecurity = n.ext.security !== 0
        this.shareInfo.isApprove = n.ext.approval !== 0
        this.shareInfo.isLogin = n.ext.islogin
        // 处理其他逻辑
      },
      immediate: true,
      deep: true,
    },
    shareInfo: {
      handler(n) {
        if (n.isSecurity) this.eodTipH = 44
      },
      immediate: true,
      deep: true,
    },
    /**
             * 切换换灯片模式的预览
             */
    isSideMode(n) {
      this.checkMimeType() // 检测底部栏是否要显示
      this.$store.commit('GET_IS_SIDEMODE', n)
      this.$refs.bsswitch.init()
    },
  },
  created() {
    this.init()
  },
  mounted() {
    window.addEventListener('message', this.viewError, false)
  },
  destroyed() {
    window.removeEventListener('message', this.viewError)
  },
  methods: {
    /**
             * 设置顶部按钮显示的方法
             */
    getTopBtnShow(data) {
      const power = resolveFileAction(data.access_mode)
      // 含有下载权限，并且该文件不是apk类型的文件
      if (/download/.test(power) && !/\.apk$/.test(data.mime_type)) {
        this.topBtnPower.showDown = true
      }
      // 只要有下载权限就可以转存数据
      if (/download/.test(power) && !this.shareInfo.isSecurity) {
        this.topBtnPower.showSaveBox = true
      }
    },
    /**
             * 文件的下载
             */
    downFile() {
      if (Object.keys(this.metaData).length < 1) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      // 下载数据
      linkDownLoad(this.shareInfo, this.$store.state.curFileInfo, [this.metaData])
    },

    /**
             * 转存
             */
    saveBox() {
      if (Object.keys(this.metaData).length < 1) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
      }
      this.selectedData = [{ data: this.metaData }]

      // 判断用户是否登录
      _$.getData('getUserInfo').then((res) => {
        if (res.status === 200) {
          if (res.data.state === 401) {
            Util.gotoLogin()
          } else {
            sessionStorage.removeItem('openSave')
            this.dialogComponent = 'transferSave'
            this.dialog.isShow = true
            this.dialog.title = this.$t('转存至网盘')
          }
        } else {
          this.saveNeids()
          gotoLogin()
        }
      }).catch(() => {
        this.saveNeids()
        gotoLogin()
      })
    },
    /**
             * 获取选中数据的neid
             */
    getNeids() {
      if (this.data.ext.islogin) {
        const neids = JSON.parse(sessionStorage.getItem('openSave'))
        if (neids) {
          this.$nextTick(() => {
            this.saveBox()
          })
        }
      }
    },
    /**
             * 存储选中数据的neid
             */
    saveNeids() {
      let result = []
      if (!this.selectedData) result = []
      result = this.selectedData.map((v) => v.data.neid)
      sessionStorage.setItem('openSave', JSON.stringify(result))
    },
    /**
             * 关闭弹框
             */
    closeDialog() {
      this.dialog.isShow = false
    },
    /**
             * 转存成功后的回调
             */
    successBack() {

    },
    /**
      * 初始化
      * @param {Object} paramData为getmetadata的参数中的token
      */
    async init(paramData) {
      const params = paramData || {} // getMetaData的参数
      const tokenRes = getAuthToken(this.data.deliverycode) // 5分中内的判断
      this.authData.folder_id = tokenRes.folder_id || this.data.deliverycode
      this.authData.password = tokenRes.password || ''
      this.authData.token = tokenRes.token || ''
      if (this.data.ext.protected) { // 判断是否需要输入提取码
        if (!params.token) { // 是否已有验证获取的token
          if (!tokenRes.hasToken) {
            this.isAuth = true
            return
          }
          params.token = tokenRes.token
        }
      }
      let data = {}
      try {
        data = await this.getMetaData(this.data.deliverycode, params)
        params.code = this.data.deliverycode
        data.requestParam = params
        if (this.shareInfo.isLogin) {
          sendLogBuryingPointMethods({
            category: 4,
            action: 404,
            pathType: this.$store.state.curFileInfo.path_type,
            entityStr1: data.neid,
            nsid: data.nsid,
          })
        }
        this.$store.commit('GET_CUR_FILE_INFO', data)
        this.$nextTick(() => {
          this.getNeids()
        })
      } catch (e) {
        const error = (e.response && e.response.data) || {}
        const state = error.state || 403
        if (state === 403 && error.code === 'forbidden') {
          this.isForbidden = true
          return
        }
        if (state === 403) {
          this.isAuth = true
          return
        }
        this.isAuth = false
        const errCfg = {
          404: { type: 'invalidLose' }, // 已失效
          409: { type: 'lowSecret' }, // 低密级
          500: { type: 'loadFail' }, // 加载失败
        }
        this.abnormalType = errCfg[state].type
        this.metaData = {}
        this.displayRightPanel = false // 不显示右侧栏
        this.isShowFoot = false // 不显示底部栏
        return
      }
      this.isAuth = false
      this.metaData = Object.assign(data, this.authData)
      this.metaData.delivery_ad = (this.data.ext && this.data.ext.deliveryAd) === '1' || false // 合并data（delivery/actionView获取）到metaData（delivery/metadata获取）
      this.metaData.shareInfo = this.shareInfo
      // 是否支持预览（权限，大小，体验版，类型等）
      const preSupport = await this.checkPreSupport() || {}
      this.getTopBtnShow(this.metaData) // 头部按钮如何显示
      const ctime = (this.data.ext && this.data.ext.ctime).toString() || ''
      const deliveryInfo = { // 外链文件最近访问信息
        neid: this.metaData.neid || '',
        nsid: this.metaData.nsid || '',
        deliverycreator: this.metaData.delivery_creator,
        deliveryfilename: this.metaData.path ? this.metaData.path.substring(1) : '',
        delivery_ctime: ctime.substring(0, 16),
        expiration: formatDate(this.metaData.expiration, 'yyyy-MM-dd hh:mm'),
        deliverydescription: this.metaData.delivery_desc,
        deliveryId: this.data.deliverycode,
      }
      this.sendRecent(deliveryInfo) // 最近访问
      if (preSupport.canPreview) { // 正常预览
        this.abnormalType = '' // 可以预览时，不显示异常
        this.checkMimeType() // 通过文件类型判断 是否显示底部栏
        this.$nextTick(() => {
          this.$refs.bsswitch.startPreview(this.metaData) // 开始预览
        })
        return
      }
      // 异常
      this.showAbornomal(preSupport)
      this.isShowFoot = false // 异常时，不显示底部栏
    },
    /**
             * 获取外链文件信息
             */
    async getMetaData(neid, params) {
      params.interface_version = 2020
      const url = `/v2/delivery/metadata/${neid}`
      let d = await _$.getData(url, params)
      d = d.data
      return d
    },
    /**
             * 验证组件验证通过后，emit的事件
             */
    async authToken(data) {
      const params = {
        token: data.token,
      }
      this.init(params) // token验证
    },
    /**
             * 验证文件类型是否支持底部栏操作，不支持时影响底部栏
             * 目前是excel和幻灯片模式 一类的文件走owa，在外链里没有底部栏
             */
    checkMimeType() {
      if (this.abnormalType) return
      const type = this.metaData.mime_type
      if (isExcel(type) || this.isSideMode) {
        this.isShowFoot = false
        return
      }
      this.isShowFoot = true
    },
    /*
             * 关闭eod header tip
             */
    closeHeaderTip() {
      this.eodTipH = 0
    },
    /**
             * 回去eod下载地址
             */
    eodUrl() {
      // if (document.domain.indexOf('.cn') > -1) return "https://res.box.lenovo.com.cn/download/eod.rar";
      // return "https://res.box.lenovo.com/download/eod.rar";
      return resolveMultiDomain('https://res.box.lenovo.com/download/eod.rar')
    },
    /**
             * toggle 右侧栏
             */
    // toggleRightPanel(val) {
    //     this.displayRightPanel = val
    // },
    /** 控制右侧栏 */
    toggleRightColumn() {
      this.displayRightPanel = !this.displayRightPanel
    },
    /**
             * 异常函数的操作事件
             */
    abnormal(key) {
      const cfg = {
        download: 'downFile', // download
        refresh: 'init', // refresh
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    /**
             * 校验doc档预览
             * 超过文件限制，或者幻灯片模式是否要预览
             */
    docCheck() {
      if (!this.metaData) {
        return false
      }
      return !isExcel(this.metaData.mime_type) && !this.isSideMode && this.abnormalType !== 'oversize'
    },
    /**
             * 异常报错
             */
    viewError(e) {
      if (e && e.data === 'pdfLoadError') { // 监听到pdf报错信息，调用异常组件
        this.abnormalType = 'loadFail'
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/link.less';
.link-box {
  .link-box-body{
    position: absolute;
  }
  .link-header-tip{
    font-size: 14px;
    line-height: 20px;
    position: relative;
    .download-area{
      color: #005EFE;
    }
    .close-icon{
      width: 14px;
      height: 14px;
      vertical-align: middle;
      position: absolute;
      top: 50%;
      right: 0px;
      margin-top: -7px;
      margin-right: 24.6px;
      cursor: pointer;
    }
  }
  .lh-50{
    .eod-download{
      margin-top: 9px;
      .eod-download-icon{
        width: 20px;
        height: 20px;
        float: left;
        margin-top: 6px;
      }
    }
    .right-pannel{
      min-width: 32px;
      padding: 0;
      .right-pannel-icon{
        width: 24px;
        height: 24px;
        vertical-align: -6px;
        display: inline-block;
      }
    }
  }
}
</style>
